import React, { useEffect, createElement } from 'react';
import { Hero, SocialProof, Testimonials1, Problem } from './components/HeaderSections';
import { ProductTomos, Bonuses, UrgencyCounter, Pricing, Potenciador } from './components/CoreSections';
import { Testimonials2, Guarantee, FAQ, CostOfNotHaving, FinalCTA, Footer } from './components/FooterSections';
import { SocialProofPopup } from './components/SocialProofPopup';
import { MetaPixel } from './components/MetaPixel';
// Helper: ensure a <meta> tag with given attributes exists in <head>
const ensureMeta = (attrs: Record<string, string>) => {
  if (typeof document === 'undefined') return;
  const selector = Object.entries(attrs).filter(([k]) => k !== 'content').map(([k, v]) => `[${k}="${v}"]`).join('');
  let meta = document.head.querySelector<HTMLMetaElement>(`meta${selector}`);
  if (!meta) {
    meta = document.createElement('meta');
    document.head.appendChild(meta);
  }
  Object.entries(attrs).forEach(([k, v]) => meta!.setAttribute(k, v));
};
// Helper: ensure a <link> tag exists in <head>
const ensureLink = (attrs: Record<string, string>) => {
  if (typeof document === 'undefined') return;
  const selector = `link[rel="${attrs.rel}"][href="${attrs.href}"]`;
  if (document.head.querySelector(selector)) return;
  const link = document.createElement('link');
  Object.entries(attrs).forEach(([k, v]) => link.setAttribute(k, v));
  document.head.appendChild(link);
};
export function App() {
  useEffect(() => {
    if (typeof document === 'undefined') return;
    // Language + translation blocking (Spanish - Latin America)
    document.documentElement.lang = 'es-419';
    document.documentElement.setAttribute('translate', 'no');
    document.title = 'MEGAPACK Funcional 365 — Todo tu año de funcional, listo';
    ensureMeta({
      'http-equiv': 'content-language',
      content: 'es-419'
    });
    ensureMeta({
      name: 'google',
      content: 'notranslate'
    });
    ensureMeta({
      name: 'language',
      content: 'Spanish'
    });
    ensureMeta({
      name: 'description',
      content: 'MEGAPACK Funcional 365: 6 Tomos, 365 sesiones, 5 bonos estratégicos. Todo tu año de clases de funcional, listo desde hoy.'
    });
    ensureMeta({
      name: 'viewport',
      content: 'width=device-width, initial-scale=1, viewport-fit=cover'
    });
    // Performance: preconnect to Google Fonts (faster font load)
    ensureLink({
      rel: 'preconnect',
      href: 'https://fonts.googleapis.com'
    });
    ensureLink({
      rel: 'preconnect',
      href: 'https://fonts.gstatic.com',
      crossorigin: ''
    });
    // Performance: preconnect to the CDN serving the hero mockup
    ensureLink({
      rel: 'preconnect',
      href: 'https://cdn.magicpatterns.com'
    });
    ensureLink({
      rel: 'preload',
      as: 'image',
      href: 'https://cdn.magicpatterns.com/uploads/gQtkVod4u9DhJDMUTT1MKv/mockup_sticker.png',
      // @ts-ignore
      fetchpriority: 'high'
    });
    // Performance: warm up both checkout connections so CTA clicks navigate
    // instantly. TCP + TLS happens in the background while the user reads.
    ensureLink({
      rel: 'dns-prefetch',
      href: 'https://funcional-365.impultienda.ar'
    });
    ensureLink({
      rel: 'preconnect',
      href: 'https://funcional-365.impultienda.ar',
      crossorigin: ''
    });
    ensureLink({
      rel: 'dns-prefetch',
      href: 'https://centershop.store'
    });
    ensureLink({
      rel: 'preconnect',
      href: 'https://centershop.store',
      crossorigin: ''
    });
  }, []);
  return <div lang="es-419" translate="no" className="min-h-screen bg-bg-base font-sans text-txt-body selection:bg-brandOrange selection:text-white notranslate" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <SocialProofPopup data-id="element-2" />
      <Hero data-id="element-3" />
      <SocialProof data-id="element-4" />
      <Testimonials1 data-id="element-5" />
      <Problem data-id="element-6" />
      <ProductTomos data-id="element-7" />
      <Bonuses data-id="element-8" />
      <UrgencyCounter data-id="element-9" />
      <Pricing data-id="element-10" />
      <Potenciador data-id="element-11" />
      <Testimonials2 data-id="element-12" />
      <Guarantee data-id="element-13" />
      <FAQ data-id="element-14" />
      <CostOfNotHaving data-id="element-15" />
      <FinalCTA data-id="element-16" />
      <Footer data-id="element-17" />
    </div>;
}